/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconClockSmallThick(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 12 12"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        d="M6 3.55c.349 0 .632.283.632.631v1.444c0 .073.03.145.081.197l1.099 1.097c.215.216.242.55.08.794l-.08.1a.634.634 0 0 1-.894 0l-1.097-1.1a1.54 1.54 0 0 1-.452-1.088V4.18c0-.349.283-.63.631-.631"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6 0c3.364 0 6 2.637 6 6s-2.636 6-6 6-6-2.636-6-6 2.637-6 6-6m0 1.264c-2.665 0-4.736 2.07-4.736 4.736S3.335 10.737 6 10.737c2.666 0 4.736-2.071 4.737-4.737 0-2.665-2.071-4.736-4.737-4.736"
        clipRule="evenodd"
      />
    </svg>
  );
}
